import script from "./chat-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./chat-layout.vue?vue&type=script&setup=true&lang=js"

import "./chat-layout.vue?vue&type=style&index=0&id=f631b2da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f631b2da"]])

export default __exports__